import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";
import { EXTRA } from "./extra_translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lfo_lang") || "en");
  useEffect(() => {
    localStorage.setItem("lfo_lang", lang);
  }, [lang]);
  const t = (key) => EXTRA[lang]?.[key] ?? EXTRA.en[key] ?? translations[lang]?.[key] ?? translations.en[key] ?? key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
